import { IRowToAdd } from 'dromo-uploader-js/dist/interfaces'

export interface DuplicateCheckResult {
  dupCount: number
  rowsToAdd: IRowToAdd[]
  rowIdsToRemove: string[]
}

export const dupParentMsg = 'Duplicated by following row(s)'
export const dupChildMsg = 'Duplicate of row above'
